import axios from 'axios';
import { setBlockTracking } from 'vue';
import addresstypes from './addresstypes';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [
    ],
    loaded : false,
    addNew : false,
})

  // getters
  const getters = {
    getConditions: (state) => (type) => {
        return state.list.filter(item => item.type == type);
    }
  }

  // actions
  const actions = {
    async load({commit, state, rootState}){
        commit("loaded", false);
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/companyTypes").then((response) => {
                commit("set", response.data.data);
                commit("loaded", true);
            });
    }
  }

  // mutations
  const mutations = {
    clean(state){
      state.list = [];
      state.loaded = false;
    },
      set(state, data){
        state.list = data;
      },
      loaded(state,status){
          state.loaded = status;
      },
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
